import React from "react";
import { ClipboardCheck, ClipboardList, Globe, Zap } from "lucide-react";
import { Link } from 'react-router-dom';
import FoundryCard from './FoundryCard';

export type SanctionsTab = "check" | "review" | "approved" | "countries";

const ComboKeyTabs: React.FC<{
  active: SanctionsTab;
  canManage: boolean;
}> = ({ active, canManage }) => (
  <nav aria-label="Sanctielijst onderdelen" className="mt-8 flex flex-col gap-4">
    {([
      { tab: "check", label: "Snelle controle", Icon: Zap, to: '/combo-key-checker' },
      { tab: "review", label: "Combo Keys beoordelen", Icon: ClipboardList, to: '/combo-key-approvals' },
      { tab: "approved", label: "Beoordeelde Combo Keys", Icon: ClipboardCheck, to: '/combo-key-approvals?tab=approved' },
      { tab: "countries", label: "HS-landen", Icon: Globe, to: '/hs-landen' },
    ] as const).filter(({tab}) => tab === 'check' || canManage).map(({ tab, label, Icon, to }) => (
      <Link key={tab} to={to} aria-current={active === tab ? "page" : undefined}
        className="block outline-none focus-visible:ring-2 focus-visible:ring-orange-400">
        <FoundryCard selected={active === tab} className="hover:border-orange-300 dark:hover:border-orange-400/50">
          <div className="flex items-center gap-2">
            <Icon className="h-4 w-4 shrink-0 text-orange-500" aria-hidden="true"/>
            <span className={`whitespace-nowrap text-sm text-slate-800 dark:text-slate-100 ${active === tab ? 'font-semibold' : 'font-normal'}`}>{label}</span>
          </div>
        </FoundryCard>
      </Link>
    ))}
  </nav>
);

export default ComboKeyTabs;
